import React from "react";
import styled from "styled-components";
import { useNavigate }  from "react-router";
import { FormattedMessage } from "react-intl";
import { Layout } from "../Layout";
import { Routes } from "constants/routes";
import { Title } from "components/Auth/components/Title";
import { Text } from "components/Auth/components/Text";
import { Button } from "ui-kit/Button";

export const NewPasswordCompleted = () => {
  const navigate = useNavigate();

  const onGetStart = () => navigate(Routes.SignIn);

  return (
    <Layout>
      <Container>
        <Title>
          <FormattedMessage id="Auth.NewPassword.Completed.Title" defaultMessage="Everything is ready"/>
        </Title>
        <Subtitle>
          <FormattedMessage id="Auth.NewPassword.Completed.Subtitle" defaultMessage="You have updated your password and logged into your account"/>
        </Subtitle>
        <Button onClick={onGetStart}>
          <FormattedMessage id="Auth.NewPassword.Completed.Button" defaultMessage="Get started"/>
        </Button>
      </Container>
    </Layout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 54px;
  height: 100%;
  max-width: 548px;

  @media (max-width: 1200px) {
    max-width: 100%;
  }
`;

const Subtitle = styled(Text)`
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
`;
